import ENV_VARS_CONSTANTS from 'freely-shared-env-vars/envVars.json';

import * as Sentry from '@sentry/react';

const isProd = process.env.MODE?.toLowerCase().startsWith('prod');

const SENTRY_DSN =
  'https://3ce7f14d15c66fc6ffe1bdea9467b39c@o347231.ingest.sentry.io/4505678863597568';

export const initSentry = () => {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.VITE_ENV,
    tracesSampleRate: 1.0,
    tracePropagationTargets: [/^https:\/\/rest\.gofreely\.xyz/],
    beforeSend(event) {
      return checkSentryEnabled() ? event : null;
    },
    enabled: checkSentryEnabled(),
    release: `${import.meta.env.VITE_ENV}:${
      ENV_VARS_CONSTANTS.APP_VERSION?.[import.meta.env.VITE_ENV]
    }`,
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        // Specify the application keys that you specified in the Sentry bundler plugin
        filterKeys: ['freely-widget'],
        behaviour: 'drop-error-if-contains-third-party-frames',
      }),
    ],
  });

  Sentry.setTags({
    STAGE: import.meta.env.VITE_ENV,
    version: ENV_VARS_CONSTANTS.APP_VERSION?.[import.meta.env.VITE_ENV],
  });
};

export const checkSentryEnabled = () => {
  if (isProd) {
    return true;
  }

  try {
    // eslint-disable-next-line
    // @ts-ignore
    const isSentryEnabled = localStorage.getItem('IS_SENTRY_ENABLED');

    return isSentryEnabled === 'true';
  } catch {
    // do nothing
  }

  return false;
};

export const toggleSentryEnabled = () => {
  try {
    const isEnabled = checkSentryEnabled();
    // eslint-disable-next-line
    // @ts-ignore
    localStorage.setItem('IS_SENTRY_ENABLED', isEnabled ? 'false' : 'true');
  } catch {
    // do nothing
  }
};

type SubmitEvent = 'quote';
type FetchEvent = 'destinations' | 'featureFlags' | 'remoteConfig';
type EffectEvent = 'init';

type WidgetEvent =
  | `submit.${SubmitEvent}`
  | `fetch.${FetchEvent}`
  | `effect.${EffectEvent}`
  | 'missing.translation';

export const sentryTags = ({ source, event }: { source: string; event: WidgetEvent }) => {
  Sentry.getCurrentScope()?.setTags({
    source,
    event,
  });
};
